import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import styles from "./Datenschutz.module.scss";

export default function Datenschutz() {
  useEffect(() => {
    document.title = "Datenschutzerklärung | Alex Rodriguez";
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className={styles.legal}>
      <div className={styles.container}>
        <Link className={styles.back} to="/">
          ← Zurück zum Portfolio
        </Link>

        <h1 className={styles.title}>Datenschutzerklärung</h1>
        <p className={styles.updated}>Stand: September 2025</p>

        <h2 className={styles.sectionTitle}>1. Verantwortlicher</h2>
        <p className={styles.text}>
          Verantwortlicher im Sinne der Datenschutz-Grundverordnung (DSGVO) ist:
        </p>
        <address className={styles.address}>
          Alex Rodriguez
          <br />
          Quellenstraße 14
          <br />
          86165 Augsburg
          <br />
          Deutschland
          <br />
          <br />
          Telefon:{" "}
          <a className={styles.link} href="tel:+491633833515">
            +49 163 3833515
          </a>
          <br />
          E-Mail:{" "}
          <a
            className={styles.link}
            href="mailto:alex.rodriguez.vera@hotmail.com"
          >
            alex.rodriguez.vera@hotmail.com
          </a>
        </address>

        <h2 className={styles.sectionTitle}>2. Allgemeine Hinweise</h2>
        <p className={styles.text}>
          Der Schutz Ihrer personenbezogenen Daten ist uns wichtig. Personenbezogene
          Daten sind alle Informationen, mit denen Sie persönlich identifiziert
          werden können. Diese Datenschutzerklärung informiert Sie darüber, welche
          Daten wir auf dieser Website erheben, wofür wir sie nutzen und welche
          Rechte Ihnen zustehen.
        </p>
        <p className={styles.text}>
          Diese Website dient als persönliches Portfolio und zur Kontaktaufnahme.
          Es werden keine Werbeprofile erstellt und keine Tracking-Analysen
          eingesetzt.
        </p>

        <h2 className={styles.sectionTitle}>3. Hosting und Server-Logfiles</h2>
        <p className={styles.text}>
          Diese Website wird bei einem externen Hosting-Anbieter betrieben (IONOS
          SE, Elgendorfer Str. 57, 56410 Montabaur, Deutschland). Beim Aufruf
          der Website werden automatisch technische Informationen in
          Server-Logfiles gespeichert, z.&nbsp;B.:
        </p>
        <ul className={styles.list}>
          <li>IP-Adresse</li>
          <li>Datum und Uhrzeit der Anfrage</li>
          <li>aufgerufene Seite/URL</li>
          <li>Browsertyp und -version</li>
          <li>verwendetes Betriebssystem</li>
          <li>Referrer-URL</li>
        </ul>
        <p className={styles.text}>
          Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO
          (berechtigtes Interesse an der sicheren und stabilen Bereitstellung
          der Website). Die Logfiles werden in der Regel nach kurzer Zeit
          automatisch gelöscht, sofern keine Sicherheitsvorfälle eine längere
          Speicherung erfordern.
        </p>

        <h2 className={styles.sectionTitle}>4. Kontaktformular und E-Mail-Kontakt</h2>
        <p className={styles.text}>
          Wenn Sie uns über das Kontaktformular eine Nachricht senden, verarbeiten
          wir folgende Daten:
        </p>
        <ul className={styles.list}>
          <li>Name</li>
          <li>E-Mail-Adresse</li>
          <li>Betreff</li>
          <li>Nachrichtentext</li>
        </ul>
        <p className={styles.text}>
          Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO
          (vorvertragliche Kommunikation) bzw. Art. 6 Abs. 1 lit. f DSGVO
          (berechtigtes Interesse an der Beantwortung von Anfragen).
        </p>
        <p className={styles.text}>
          Zur Übermittlung des Formulars nutzen wir den Dienst{" "}
          <strong>EmailJS</strong> (EmailJS.com). Dabei werden Ihre Angaben an
          die Server von EmailJS übertragen, um die Nachricht an uns weiterzuleiten.
          Anbieter: EmailJS Pte. Ltd., Singapur. Weitere Informationen:{" "}
          <a
            className={styles.link}
            href="https://www.emailjs.com/legal/privacy-policy/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Datenschutz bei EmailJS
          </a>
          .
        </p>
        <p className={styles.text}>
          Die Daten werden nur zur Bearbeitung Ihrer Anfrage verwendet und nicht
          ohne Ihre Einwilligung an Dritte weitergegeben, sofern keine gesetzliche
          Verpflichtung besteht.
        </p>

        <h2 className={styles.sectionTitle}>5. Schriftarten (Google Fonts)</h2>
        <p className={styles.text}>
          Diese Website nutzt Google Fonts zur einheitlichen Darstellung von
          Schriftarten. Anbieter ist Google Ireland Limited, Gordon House, Barrow
          Street, Dublin 4, Irland.
        </p>
        <p className={styles.text}>
          Beim Aufruf der Seite wird Ihre IP-Adresse an Google übermittelt, da
          die Schriftarten von Google-Servern geladen werden. Rechtsgrundlage ist
          Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an einer
          ansprechenden Darstellung).
        </p>
        <p className={styles.text}>
          Weitere Informationen:{" "}
          <a
            className={styles.link}
            href="https://policies.google.com/privacy"
            target="_blank"
            rel="noopener noreferrer"
          >
            Google Datenschutzerklärung
          </a>
          .
        </p>

        <h2 className={styles.sectionTitle}>6. Externe Links (Social Media)</h2>
        <p className={styles.text}>
          Auf dieser Website befinden sich Links zu externen Profilen (GitHub,
          Twitter/X, Instagram). Erst wenn Sie auf einen Link klicken, werden
          Daten an den jeweiligen Anbieter übermittelt. Für die Datenverarbeitung
          auf den externen Seiten sind ausschließlich die jeweiligen Anbieter
          verantwortlich.
        </p>

        <h2 className={styles.sectionTitle}>7. Cookies</h2>
        <p className={styles.text}>
          Diese Website setzt keine Tracking-Cookies ein. Es werden keine
          Analyse-Tools wie Google Analytics verwendet. Technisch notwendige
          Speicherungen durch Ihren Browser (z.&nbsp;B. Session-Daten) können
          dennoch erfolgen.
        </p>

        <h2 className={styles.sectionTitle}>8. Speicherdauer</h2>
        <p className={styles.text}>
          Personenbezogene Daten aus Kontaktanfragen speichern wir nur so lange,
          wie es für die Bearbeitung der Anfrage erforderlich ist oder gesetzliche
          Aufbewahrungsfristen bestehen. Server-Logfiles werden vom Hosting-Anbieter
          nur für einen begrenzten Zeitraum vorgehalten.
        </p>

        <h2 className={styles.sectionTitle}>9. Ihre Rechte</h2>
        <p className={styles.text}>
          Sie haben gegenüber uns folgende Rechte bezüglich Ihrer personenbezogenen
          Daten:
        </p>
        <ul className={styles.list}>
          <li>Auskunft (Art. 15 DSGVO)</li>
          <li>Berichtigung (Art. 16 DSGVO)</li>
          <li>Löschung (Art. 17 DSGVO)</li>
          <li>Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
          <li>Datenübertragbarkeit (Art. 20 DSGVO)</li>
          <li>Widerspruch gegen die Verarbeitung (Art. 21 DSGVO)</li>
          <li>Widerruf erteilter Einwilligungen (Art. 7 Abs. 3 DSGVO)</li>
        </ul>
        <p className={styles.text}>
          Zur Ausübung Ihrer Rechte wenden Sie sich bitte an die oben genannte
          E-Mail-Adresse.
        </p>

        <h2 className={styles.sectionTitle}>10. Beschwerderecht bei der Aufsichtsbehörde</h2>
        <p className={styles.text}>
          Sie haben das Recht, sich bei einer Datenschutz-Aufsichtsbehörde zu
          beschweren. Zuständig für Bayern ist:
        </p>
        <address className={styles.address}>
          Bayerisches Landesamt für Datenschutzaufsicht (BayLDA)
          <br />
          Promenade 18
          <br />
          91522 Ansbach
          <br />
          <a
            className={styles.link}
            href="https://www.lda.bayern.de"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.lda.bayern.de
          </a>
        </address>

        <h2 className={styles.sectionTitle}>11. Änderungen dieser Datenschutzerklärung</h2>
        <p className={styles.text}>
          Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie
          stets den aktuellen rechtlichen Anforderungen entspricht oder Änderungen
          unserer Website widerspiegelt. Die jeweils aktuelle Version finden Sie
          auf dieser Seite.
        </p>

        <nav className={styles.nav} aria-label="Rechtliche Seiten">
          <Link to="/impressum">Impressum</Link>
          <Link to="/">Portfolio</Link>
        </nav>
      </div>
    </main>
  );
}
